import type { InternalRelationMetaDataInterface } from '@nts/std/interfaces';
import { InternalAssociationMetaData } from './domain-model-meta-data';

export class InternalRelationMetaData extends InternalAssociationMetaData implements InternalRelationMetaDataInterface {

}
